<div class="dataswap-container h-100 d-flex flex-column">
  <div class="h-10 d-flex flex-column">
    <div class="dataswap-container-title">
        @if(isInTab() === false){
          <h1 class="title-center">DataSwap</h1>
        }
        @else {
          <h5 class="title-center">DataSwap</h5>
        }
    </div>
    @if (selectedInfoRecord)
    {
      <div class="title-center">
        <button matButton="outlined" [disabled]="loadingWorkbook || !checkAccess(['LOSTalker.Integration.LimeGear', 'LOSTalker.Integration.CompenSafe'])" class="btn-orange"
        (click)="getIntegrationWorkbook()">
          @if (loadingWorkbook)
          {
            <span>Generating...</span>
          }
          @else
          {
            <span>Get Current Workbook</span>
          }
        </button>
      </div>
    }
  </div>

  <div class="h-90 mt-2">
    @if(loadingFinished && integrationInformationList && integrationIdentifiers)
    {
      <div class="dataswap-container-main">

        <mat-tab-group class="dataswap-tabs lt-tabs mt-2"
          animationDuration="0ms"
          mat-align-tabs="center"
          mat-stretch-tabs="false" 
          (selectedTabChange)="onTabSelect($event)">
          
          <mat-tab label="Get File XML">
            <div class="flexWrap">
              <div class="flexInputCol">

                @if (!isInTab())
                {
                  @if (checkAccess(['LOSTalker.DevOps','LOSTalker.Admin']))
                  {
                    <app-lt-switch class="switch-width"
                        [(ngModel)]="selectByLTClient"
                        [onLabel]="'LOS Talker Client'"
                        [offLabel]="'Company Id and Name'"
                        (toggleChange)="changeSelectionMethod($event)">
                    </app-lt-switch>
                  }
                  <br>
                  <br>

                  @if (!selectByLTClient)
                  {
                    @if (destinationListOptions.length > 1)
                    {
                      <mat-form-field appearance="fill" class="selector-field">
                        <mat-label>Destination</mat-label>
                        <mat-select
                            (selectionChange)="selectDestination($event.value)"
                            [formControl]="destinationListFormControl">
                          @for (option of destinationListOptions; track option) {
                            <mat-option [value]="option">
                              {{option}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (destinationListOptions.length === 1 && validDestination)
                    {
                      <h5>{{destination}}</h5>
                    }

                    <br>

                    @if (validDestination)
                    {
                      <mat-form-field appearance="fill" class="selector-field">
                        <mat-label>Identifier</mat-label>
                        <input type="text"
                          matInput
                          placeholder="Select Client"
                          [matAutocomplete]="auto"
                          [formControl]="integrationInfoListFormControl">
                        <mat-autocomplete autoActiveFirstOption
                            #auto="matAutocomplete"
                            (optionSelected)="selectIdentifier($event.option.value)"
                            [displayWith]="displayFnIdentifier">
                          @for (option of integrationInfoFilteredList | async; track option) {
                            <mat-option [value]="option">
                              {{option.identifierIdValue}} - {{option.identifierNameValue}} - {{option.dataSourceType}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    }

                  }

                  @if (selectByLTClient)
                  {
                    @if(clientSelected === false)
                    {
                      <mat-form-field appearance="fill" class="selector-field">
                        <mat-label>Client</mat-label>
                        <input type="text"
                          matInput
                          placeholder="Select Integration"
                          [matAutocomplete]="auto"
                          [formControl]="clientFormControl">
                        <mat-autocomplete autoActiveFirstOption
                            #auto="matAutocomplete"
                            (optionSelected)="selectClient($event.option.value)"
                            [displayWith]="displayFnClient">
                          @for (option of clientsFiltered | async; track option) {
                            <mat-option [value]="option">
                              {{option.clientDisplayName}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                      <br>
                    }
                    @else
                    {
                      <div class="flex-center">
                        <h2>Client: {{selectedClient.clientDisplayName}}</h2>
                        @if (!isInTab())
                        {
                          <button title="Edit Client" class="btn float-right" (click)="editClient()"><i class="bi bi-pencil"></i></button>
                        }
                      </div>
                      @if (!clientAndIntegrationProvided)
                      {
                        <br>
                      }
                      @if (!integrationSelected)
                      {
                        <mat-form-field appearance="fill" >
                          <mat-label>Integration</mat-label>
                          <input type="text"
                            title="Select Integration"
                            matInput
                            [matAutocomplete]="auto"
                            [formControl]="integrationFormControl">
                          <mat-autocomplete autoActiveFirstOption
                              #auto="matAutocomplete"
                              (optionSelected)="selectIntegration($event.option.value)"
                              [displayWith]="displayFnIntegration">
                            @for (option of integrationsFiltered | async; track option) {
                              <mat-option [value]="option" >
                                {{option.name}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                        <br>
                      }
                    }

                    @if (integrationSelected)
                    {
                      <div class="flex-center">
                        <h5>Integration: {{selectedIntegration.name}}</h5>
                        @if (!isInTab())
                        {
                          <button title="Edit Integration" class="btn float-right" (click)="editIntegration()"><i class="bi bi-pencil"></i></button>
                        }
                      </div>
                    }
                    
                  }
                }               

                @if (isInTab())
                {
                  
                  @if (integrationInformationList.length === 1)
                  {
                    <br>
                    <h4>{{selectedInfoRecord.destinationName}} - {{selectedInfoRecord.identifierIdValue}} -
                    {{selectedInfoRecord.identifierNameValue}}</h4>
                    <br>
                  }

                  @if (integrationInformationList.length > 1)
                  {
                    <mat-form-field appearance="fill" class="selector-field" >
                      <mat-label>Identifier</mat-label>
                      <input type="text"
                        matInput
                        title="Select Identifier"
                        [matAutocomplete]="auto"
                        [formControl]="integrationInfoListFormControl">
                      <mat-autocomplete autoActiveFirstOption
                          #auto="matAutocomplete"
                          (optionSelected)="selectIdentifier($event.option.value)"
                          [displayWith]="displayFnIdentifier">
                        @for (option of integrationInfoFilteredList | async; track option) {
                          <mat-option [value]="option" >
                            {{option.destinationName}} - {{option.identifierIdValue}} - {{option.identifierNameValue}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                }

                @if (!credentialsLoaded && selectedInfoRecord)
                {
                  <app-lt-spinner></app-lt-spinner>
                }
                
                @if (credentialsLoaded && selectedInfoRecord)
                {
                    <br>
                    <mat-form-field appearance="fill" >
                      <mat-label>File Type Request</mat-label>
                      <input
                        type="text"
                        title="Select File Type"
                        matInput
                        [value]="fileTypeInputValue()"
                        (input)="updateFileTypeInput($event.target.value)"
                        [matAutocomplete]="auto">
                      @if (fileTypeInputValue())
                      {
                        <button
                          matSuffix
                          matIconButton
                          aria-label="Clear"
                          (click)="clearFileTypeInput()">
                          <mat-icon>close</mat-icon>
                        </button>
                      }
                      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="onFileTypeOptionSelected($event)">
                        @for(option of filteredFileTypeOptions(); track option){
                          <mat-option [value]="option">{{option}}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <br>

                    <mat-form-field appearance="fill">
                      <mat-label>Latest Files To Pull</mat-label>
                      <mat-select [(value)]="latestNo">
                        @for (option of latestNoOptions; track option) {
                          <mat-option [value]="option">
                            {{option}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <br>

                    <app-lt-button (click)="submitDataSwapRequest('file')" label="Invoke" [disabled]="requestLoading"></app-lt-button>
                    @if (validToShowPushBack())
                    {
                      <app-lt-button class="margin-left-2" (click)="navigateToPushBack($event)" label="View PushBacks" [disabled]="requestLoading"></app-lt-button>
                    }

                }
                  
              </div>
              <div class="flexMonacoCol">
                @if (displayMonaco1 || displayMonaco2 || displayMonaco3)
                {
                  <mat-tab-group #fileTabGroup
                    class="dataswap-tabs mt-2" 
                    animationDuration="0ms" 
                    [selectedIndex]="tabId" 
                    (selectedTabChange)="onFileTabSelect($event)"
                    mat-align-tabs="center">
                        @if (displayMonaco1)
                        {
                          <mat-tab label="Latest #1">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco1
                                (textChange)="updateData($event,1)"
                                [editorData]="monacoData1"
                                [lang]="'xml'"
                                [editAccess]="false">
                                </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }
                        
                        @if (displayMonaco2)
                        {
                          <mat-tab label="Latest #2">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco2
                                (textChange)="updateData($event,2)"
                                [editorData]="monacoData2"
                                [lang]="'xml'"
                                [editAccess]="false">
                              </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }
                        @if (displayMonaco3)
                        {
                          <mat-tab label="Latest #3">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco3
                                (textChange)="updateData($event,3)"
                                [editorData]="monacoData3"
                                [lang]="'xml'"
                                [editAccess]="false">
                              </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }
                  </mat-tab-group>
                }
                @else if(requestLoading)
                {
                  <div class="m-auto text-center">
                    <app-lt-spinner></app-lt-spinner>
                  </div>
                }
              </div>

            </div>
          </mat-tab>

          <mat-tab label="Get Loan XML">
            <div class="flexWrap">
                <div class="flexInputCol">

                  @if (!isInTab())
                  {
                    
                    @if (checkAccess(['LOSTalker.DevOps','LOSTalker.Admin']))
                    {
                      <app-lt-switch class="switch-width"
                          [(ngModel)]="selectByLTClient"
                          [onLabel]="'LOS Talker Client'"
                          [offLabel]="'Company Id and Name'"
                          (toggleChange)="changeSelectionMethod($event)">
                      </app-lt-switch>
                    }
                    <br>
                    <br>

                    @if (!selectByLTClient)
                    {
                      @if (destinationListOptions.length > 1)
                      {
                        <mat-form-field appearance="fill" class="selector-field">
                          <mat-label>Destination</mat-label>
                          <mat-select
                              (selectionChange)="selectDestination($event.value)"
                              [formControl]="destinationListFormControl">
                            @for (option of destinationListOptions; track option) {
                              <mat-option [value]="option">
                                {{option}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                      
                      @if (destinationListOptions.length === 1 && validDestination)
                      {
                        <h5>{{destination}}</h5>
                      }

                      <br>

                      @if (validDestination)
                      {
                        <mat-form-field appearance="fill" class="selector-field" >
                          <mat-label>Identifier</mat-label>
                          <input type="text"
                            matInput
                            title="Select Identifier"
                            [matAutocomplete]="auto"
                            [formControl]="integrationInfoListFormControl">
                          <mat-autocomplete autoActiveFirstOption
                              #auto="matAutocomplete"
                              (optionSelected)="selectIdentifier($event.option.value)"
                              [displayWith]="displayFnIdentifier">
                            @for (option of integrationInfoFilteredList | async; track option) {
                              <mat-option [value]="option">
                                {{option.identifierIdValue}} - {{option.identifierNameValue}} - {{option.dataSourceType}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      }

                    }

                    @if (selectByLTClient)
                    {
                      @if (!clientSelected)
                      {
                        <mat-form-field appearance="fill" class="selector-field">
                          <mat-label>Client</mat-label>
                          <input type="text"
                            matInput
                            title="Select Client"
                            [matAutocomplete]="auto"
                            [formControl]="clientFormControl">
                          <mat-autocomplete autoActiveFirstOption
                              #auto="matAutocomplete"
                              (optionSelected)="selectClient($event.option.value)"
                              [displayWith]="displayFnClient">
                            @for (option of clientsFiltered | async; track option) {
                              <mat-option [value]="option">
                                {{option.clientDisplayName}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                        <br>
                      }

                      @if (clientSelected)
                      {
                        <div class="flex-center">
                          <h2>Client: {{selectedClient.clientDisplayName}}</h2>
                          <button title="Edit Client" class="btn float-right" (click)="editClient()"><i class="bi bi-pencil"></i></button>
                        </div>
                        @if (!clientAndIntegrationProvided)
                        {
                          <br >
                        }

                        @if (!integrationSelected)
                        {
                          <mat-form-field appearance="fill" >
                            <mat-label>Integration</mat-label>
                            <input type="text"
                              matInput
                              title="Select Integration"
                              [matAutocomplete]="auto"
                              [formControl]="integrationFormControl">
                            <mat-autocomplete autoActiveFirstOption
                                #auto="matAutocomplete"
                                (optionSelected)="selectIntegration($event.option.value)"
                                [displayWith]="displayFnIntegration">
                              @for (option of integrationsFiltered | async; track option) {
                                <mat-option [value]="option" >
                                  {{option.name}}
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                          <br>
                        }
                      }

                      @if (integrationSelected)
                      {
                        <div class="flex-center">
                          <h5>Integration: {{selectedIntegration.name}}</h5>
                          <button title="Edit Integration" class="btn float-right" (click)="editIntegration()"><i class="bi bi-pencil"></i></button>
                        </div>
                        @if (!clientAndIntegrationProvided)
                        {
                          <br>
                        }
                      }

                      @if (integrationSelected && selectedInfoRecord)
                      {
                        <h5>Selected ID: {{selectedInfoRecord.destinationName}} - {{selectedInfoRecord.identifierIdValue}} -
                          {{selectedInfoRecord.identifierNameValue}}</h5>
                        @if (!clientAndIntegrationProvided)
                        {
                          <br>
                        }
                      }
                      @if (integrationSelected && !selectedInfoRecord)
                      {
                        <mat-form-field appearance="fill" class="selector-field">
                          <mat-label>Identifier</mat-label>
                          <input title="Select Identifier" type="text" matInput [matAutocomplete]="auto" [formControl]="integrationInfoListFormControl">
                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            (optionSelected)="selectIdentifier($event.option.value)" [displayWith]="displayFnIdentifier">
                            @for (option of integrationInfoFilteredList | async; track option) {
                              <mat-option [value]="option">
                                {{selectedInfoRecord.destinationName}} - {{selectedInfoRecord.identifierIdValue}} - {{selectedInfoRecord.identifierNameValue}}
                              </mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      }
                    }
                  }

                  @if (isInTab())
                  {
                    @if (integrationInformationList.length === 1)
                    {
                      <br>
                      <h4>{{selectedInfoRecord.destinationName}} - {{selectedInfoRecord.identifierIdValue}} -
                      {{selectedInfoRecord.identifierNameValue}}</h4>
                      <br>
                    }
                    @if (integrationInformationList.length > 1)
                    {
                      <mat-form-field appearance="fill" class="selector-field" >
                        <mat-label>Identifier</mat-label>
                        <input type="text"
                          matInput
                          placeholder="Select Integration"
                          [matAutocomplete]="auto"
                          [formControl]="integrationInfoListFormControl">
                        <mat-autocomplete autoActiveFirstOption
                            #auto="matAutocomplete"
                            (optionSelected)="selectIdentifier($event.option.value)"
                            [displayWith]="displayFnIdentifier">
                          @for (option of integrationInfoFilteredList | async; track option) {
                            <mat-option [value]="option" >
                              {{option.destinationName}} - {{option.identifierIdValue}} - {{option.identifierNameValue}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    }
                  }

                  @if (!credentialsLoaded && selectedInfoRecord)
                  {
                    <app-lt-spinner></app-lt-spinner>
                  }

                  @if (credentialsLoaded && selectedInfoRecord)
                  {
                    <br>
                    <mat-form-field appearance="fill" >
                      <mat-label>Loan Number</mat-label>
                      <input type="text"
                        matInput
                        title="Select Loan To Retrieve"
                        [(ngModel)]="loanNumber">
                    </mat-form-field>
                    <br>

                    <mat-form-field appearance="fill">
                      <mat-label>Latest Files To Pull</mat-label>
                      <mat-select [(value)]="latestNo">
                        @for (option of latestNoOptions; track option) {
                          <mat-option [value]="option">
                            {{option}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <br>

                    <app-lt-button (click)="submitDataSwapRequest('loan')" label="Invoke" [disabled]="requestLoading"></app-lt-button>
                  }

                </div>

                <div class="flexMonacoCol">

                  @if (displayMonaco1 || displayMonaco2 || displayMonaco3)
                  {
                    <mat-tab-group #loanTabGroup
                      class="dataswap-tabs mt-2"
                      animationDuration="0ms"
                      [selectedIndex]="tabId" 
                      (selectedTabChange)="onFileTabSelect($event)"
                      mat-align-tabs="center">
                        @if (displayMonaco1)
                        {
                          <mat-tab label="Latest #1">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco1
                                (textChange)="updateData($event,1)"
                                [editorData]="monacoData1"
                                [lang]="'xml'"
                                [editAccess]="false">
                              </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }
                        @if (displayMonaco2)
                        {
                          <mat-tab label="Latest #2">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco2
                                (textChange)="updateData($event,2)"
                                [editorData]="monacoData2"
                                [lang]="'xml'"
                                [editAccess]="false">
                              </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }

                        @if (displayMonaco3)
                        {
                          <mat-tab label="Latest #3">
                            <div class="tab-monaco-content">
                              <app-monaco-editor #monaco3
                                (textChange)="updateData($event,3)"
                                [editorData]="monacoData3"
                                [lang]="'xml'"
                                [editAccess]="false">
                              </app-monaco-editor>
                              <ng-container *ngTemplateOutlet="saveAllFile"></ng-container>
                            </div>
                          </mat-tab>
                        }
                    </mat-tab-group>
                  }
                  @else if(requestLoading)
                  {
                    <div class="m-auto text-center">
                      <app-lt-spinner></app-lt-spinner>
                    </div>
                  }
                </div>

              </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
    @else {
      @if (!loadingFinished) {
        <div class="m-auto text-center">
          <app-lt-spinner></app-lt-spinner>
        </div>
      }
      @else if(loadingFinished && !integrationInformationList)
      {
        <div class="m-auto text-center">
          <div class="no-records-message">Loading failed.</div>
        </div>
      }
    }

  </div>

</div>

<ng-template #saveCurrentFile>
  <hr />
  <span class="center-save-buttons">
    <button matButton="elevated" class="mx-2" (click)="saveFile()">Save Current File</button>
  </span>
</ng-template>
<ng-template #saveAllFile>
  <hr/>
  <span class="center-save-buttons">
    <button matButton="elevated" class="mx-2" (click)="saveFile()">Save Current File</button>
    <button matButton="elevated" class="mx-2" (click)="saveAllFiles()">Save All Files</button>
  </span>

</ng-template>
